import { ThemedBullsEyePointerIcon, ThemedRectangleTerminal, ThemedCalendarIcon, ThemedRedisTrigger, ThemedServerIcon, ThemedWebhookIcon, ThemedSocketIoTrigger } from "assets/CXFIcons/Triggers";

export const TOOLBOX_MINIFIED_MENU_WIDTH = 190;
export const TOOLBOX_MAXIMIZED_MENU_WIDTH = 68;
export const APPLICATION_TYPES = {
   SFTP: "sftp",
   DATABASE: "database",
   SMTP: "smtp",
   AWS: "aws",
   BEARER: "bearerToken",
   OAUTH: "oauth",
   BASIC_AUTH: "basicAuth",
   REDIS: "redis"
};
export const ACTION_TYPES = {
   STRING: "string",
   TEXT: "text",
   PASSWORD: "password",
   DROPDOWN: "dropdown",
   // MULTISELECT: "multiselect",
   SWITCH: "switch",
   CHECKBOX: "checkbox",
   BUTTON: "button",
   JSON: "json",
   LIST: "list",
   KEY_VALUE: "keyValue",
   DIVIDER: "divider",
   FILE: "file",
   // VARIABLE_SELECT: "variableSelect",
   READ_ONLY: "readOnly",
   PAYLOAD_TYPE: "payloadType",
   RADIO_GROUP: "radioGroup",
   TAG: "tag",
   CODE: "code",
   NUMBER: "number",
   EDITOR: "editor",
   SQL: "sql",
   CREDENTIAL: "credential",
   CREDENTIAL_SWITCH: "credentialSwitch",
   ERROR_HANDLING_DROPDOWN: "errorHandlingDropdown",
   SIMPLE_TAG: "simpleTag",
   CREATABLE_SELECT: "creatableSelect",
   SELECT_WITH_DETAILS: "selectWithDetails"
};
export const COMMON_COMPONENT_TYPES = {
   CONDITIONAL: "conditionalComponent",
   EXECUTION_REPORT: "executionReportComponent",
   VARIABLES: "variablesComponent",
   REST_API: "restApiComponent",
   MCP_CLIENT: "mcpClientComponent",
   EMAIL: "emailComponent",
   SFTP: "sftpComponent",
   DATABASE: "databaseComponent",
   SELECTION: "selectionComponent",
   GOTO: "goToComponent",
   CODE: "codeComponent",
   DELAY: "delayComponent",
   REDIS: "redisComponent",
   BLUE_PRISM_DELTA: "bluePrismDeltaComponent",
   END: "endComponent",
   DATA_LOGGER: "dataLoggerComponent",
   WEBHOOK: "webhookComponent",
   INVOKE: "invokeComponent",
   SESSION_STORAGE: "sessionStorageComponent",
   RESPOND: "respondComponent"
};
export const REQUIRED_CREDENTIAL_COMPONENTS = new Set([
   COMMON_COMPONENT_TYPES.DATABASE,
   COMMON_COMPONENT_TYPES.EMAIL,
   COMMON_COMPONENT_TYPES.REDIS,
   COMMON_COMPONENT_TYPES.SFTP
]);
export const COMMON_COMPONENT_NAMES = {
   CONDITIONAL: "Conditional",
   EXECUTION_REPORT: "Execution Report",
   VARIABLES: "Variables",
   REST_API: "Rest Client",
   MCP_CLIENT: "MCP Client",
   EMAIL: "Email",
   SFTP: "SFTP",
   DATABASE: "Microsoft SQL Database",
   SELECTION: "Selection",
   GOTO: "Go To",
   CODE: "Code",
   DELAY: "Delay",
   REDIS: "Redis",
   BLUE_PRISM_DELTA: "Blue Prism Delta",
   END: "End",
   DATA_LOGGER: "Data Logger",
   WEBHOOK: "Webhook Client",
   INVOKE: "Invoke",
   SESSION_STORAGE: "Session Storage",
   RESPOND: "Respond"
};

export const TRIGGER_TYPES = {
   REST_ENDPOINT: "restEndpointTrigger",
   WEBHOOK: "webhookTrigger",
   SCHEDULE: "scheduleTrigger",
   DEFAULT: "default",
   REDIS: "redisTrigger",
   BLUE_PRISM_DELTA: "bluePrismDeltaTrigger",
   SOCKET_IO: "socketIoTrigger",
   MCP: "mcpTrigger"
};

export const TRIGGER_NAMES = {
   REST_ENDPOINT: "Rest",
   WEBHOOK: "Webhook",
   SCHEDULE: "Schedule",
   DEFAULT: "Manual",
   REDIS: "Redis",
   BLUE_PRISM_DELTA: "Blue Prism Delta",
   SOCKET_IO: "Socket.Io",
   MCP: "MCP"
};

export const TRIGGER_ICON_BY_TYPE = {
   [TRIGGER_TYPES.REST_ENDPOINT]: ThemedRectangleTerminal,
   [TRIGGER_TYPES.WEBHOOK]: ThemedWebhookIcon,
   [TRIGGER_TYPES.SCHEDULE]: ThemedCalendarIcon,
   [TRIGGER_TYPES.DEFAULT]: ThemedBullsEyePointerIcon,
   [TRIGGER_TYPES.REDIS]: ThemedRedisTrigger,
   [TRIGGER_TYPES.BLUE_PRISM_DELTA]: ThemedServerIcon,
   [TRIGGER_TYPES.SOCKET_IO]: ThemedSocketIoTrigger,
   [TRIGGER_TYPES.MCP]: ThemedServerIcon
};

export const COMPONENT_VALUE_TYPES = {
   STRING: "string",
   NUMBER: "number",
   BOOLEAN: "boolean",
   NULL: "null",
   MAPPED_DATA: "mapped_data",
   RESET: "reset"
};
export const EXECUTION_REPORT_RESULT_TYPES = {
   PAGE: "Show Results on a Page",
   LOG: "Save Results to log file",
   EMAIL: "Send to Email"
};
export const TOOLBOX_MENU_ITEM_TYPES = {
   SEARCH: "search",
   COMPONENTS: "components",
   CONNECTORS: "connectors",
   FLOW_PROPERTIES: "flowProperties",
   SESSION_VIEWER: "sessionViewer",
   PREFERENCES: "preferences",
   TOOL_MANAGEMENT: "toolManagement",
   HELP: "help"
};
export const CANVAS_DIRECTIONS = {
   HORIZONTAL: "LR",
   VERTICAL: "TB"
};
export const REPORT_TYPES = {
   TABLE: "table",
   TIMELINE: "timeline"
};
export const NODE_TYPES = {
   COMMON: "commonnodes",
   CUSTOM: "customnodes",
   PLACEHOLDER: "placeholder",
   STATIC: "static",
   LABEL: "label",
   HIDDEN: "hidden",
   SUBFLOW: "subflow"
};
export const EDGE_TYPES = {
   BUTTON: "buttonedge",
   SMOTHSTEP: "smoothstep",
   LABEL: "labeledge",
   HIDDEN: "hiddencomponentedge",
   FLOATING: "floatingedge",
   STRAIGHT: "straightedge"
};
export const COMPONENT_BRANCH_FIELDS = {
   VALUE: "value",
   LABEL: "label"
};
export const CONDITION_OPERATORS = {
   EQUAL: "eq",
   NOT_EQUAL: "neq",
   GREATER_THAN: "gt",
   LESS_THAN: "lt",
   GREATER_THAN_OR_EQUAL: "gte",
   LESS_THAN_OR_EQUAL: "lte",
   CONTAINS: "contains",
   NOT_CONTAINS: "notcontains",
   IN: "in",
   NOT_IN: "notIn",
   STARTS_WITH: "startsWith",
   ENDS_WITH: "endsWith",
   IS_EMPTY: "isEmpty",
   IS_NOT_EMPTY: "isNotEmpty",
   IS_TRUE: "isTrue",
   IS_FALSE: "isFalse",
   IS_NULL: "isNull",
   IS_NOT_NULL: "isNotNull"
};
export const CONDITION_OPERATOR_LABELS = {
   [CONDITION_OPERATORS.EQUAL]: "Equal",
   [CONDITION_OPERATORS.NOT_EQUAL]: "Not Equal",
   [CONDITION_OPERATORS.GREATER_THAN]: "Greater Than",
   [CONDITION_OPERATORS.LESS_THAN]: "Less Than",
   [CONDITION_OPERATORS.GREATER_THAN_OR_EQUAL]: "Greater Than or Equal",
   [CONDITION_OPERATORS.LESS_THAN_OR_EQUAL]: "Less Than or Equal",
   [CONDITION_OPERATORS.CONTAINS]: "Contains",
   [CONDITION_OPERATORS.NOT_CONTAINS]: "Not Contains",
   [CONDITION_OPERATORS.IN]: "In",
   [CONDITION_OPERATORS.NOT_IN]: "Not In",
   [CONDITION_OPERATORS.STARTS_WITH]: "Starts With",
   [CONDITION_OPERATORS.ENDS_WITH]: "Ends With",
   [CONDITION_OPERATORS.IS_EMPTY]: "Is Empty",
   [CONDITION_OPERATORS.IS_NOT_EMPTY]: "Is Not Empty",
   [CONDITION_OPERATORS.IS_TRUE]: "Is True",
   [CONDITION_OPERATORS.IS_FALSE]: "Is False",
   [CONDITION_OPERATORS.IS_NULL]: "Is Null",
   [CONDITION_OPERATORS.IS_NOT_NULL]: "Is Not Null"
};

export const CONDITION_OPERATORS_DATASOURCE = [
   {
      value: CONDITION_OPERATORS.EQUAL,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.EQUAL]
   },
   {
      value: CONDITION_OPERATORS.NOT_EQUAL,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.NOT_EQUAL]
   },
   {
      value: CONDITION_OPERATORS.GREATER_THAN,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.GREATER_THAN]
   },
   {
      value: CONDITION_OPERATORS.LESS_THAN,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.LESS_THAN]
   },
   {
      value: CONDITION_OPERATORS.GREATER_THAN_OR_EQUAL,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.GREATER_THAN_OR_EQUAL]
   },
   {
      value: CONDITION_OPERATORS.LESS_THAN_OR_EQUAL,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.LESS_THAN_OR_EQUAL]
   },
   {
      value: CONDITION_OPERATORS.CONTAINS,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.CONTAINS]
   },
   {
      value: CONDITION_OPERATORS.NOT_CONTAINS,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.NOT_CONTAINS]
   },
   {
      value: CONDITION_OPERATORS.IN,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.IN]
   },
   {
      value: CONDITION_OPERATORS.NOT_IN,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.NOT_IN]
   },
   {
      value: CONDITION_OPERATORS.STARTS_WITH,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.STARTS_WITH]
   },
   {
      value: CONDITION_OPERATORS.ENDS_WITH,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.ENDS_WITH]
   },
   {
      value: CONDITION_OPERATORS.IS_EMPTY,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.IS_EMPTY]
   },
   {
      value: CONDITION_OPERATORS.IS_NOT_EMPTY,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.IS_NOT_EMPTY]
   },
   {
      value: CONDITION_OPERATORS.IS_TRUE,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.IS_TRUE]
   },
   {
      value: CONDITION_OPERATORS.IS_FALSE,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.IS_FALSE]
   },
   {
      value: CONDITION_OPERATORS.IS_NULL,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.IS_NULL]
   },
   {
      value: CONDITION_OPERATORS.IS_NOT_NULL,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.IS_NOT_NULL]
   }
];

export const SELECTION_OPERATORS_DATASOURCE = [
   {
      value: CONDITION_OPERATORS.EQUAL,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.EQUAL]
   },
   {
      value: CONDITION_OPERATORS.NOT_EQUAL,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.NOT_EQUAL]
   },
   {
      value: CONDITION_OPERATORS.GREATER_THAN,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.GREATER_THAN]
   },
   {
      value: CONDITION_OPERATORS.LESS_THAN,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.LESS_THAN]
   },
   {
      value: CONDITION_OPERATORS.GREATER_THAN_OR_EQUAL,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.GREATER_THAN_OR_EQUAL]
   },
   {
      value: CONDITION_OPERATORS.LESS_THAN_OR_EQUAL,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.LESS_THAN_OR_EQUAL]
   },
   {
      value: CONDITION_OPERATORS.CONTAINS,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.CONTAINS]
   },
   {
      value: CONDITION_OPERATORS.NOT_CONTAINS,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.NOT_CONTAINS]
   },
   {
      value: CONDITION_OPERATORS.IN,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.IN]
   },
   {
      value: CONDITION_OPERATORS.NOT_IN,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.NOT_IN]
   },
   {
      value: CONDITION_OPERATORS.STARTS_WITH,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.STARTS_WITH]
   },
   {
      value: CONDITION_OPERATORS.ENDS_WITH,
      text: CONDITION_OPERATOR_LABELS[CONDITION_OPERATORS.ENDS_WITH]
   }
];

export const INSERT_NODE = "insertNode";

export const TRIGGER_RESPONSE_CODES = {
   CUSTOM: "custom"
};

export const CONTEXT_FILTERS = {
   COMPONENT_STEPS: "componentSteps",
   CONNECTOR_STEPS: "connectorSteps",
   SUCCESSFUL_STEPS: "successfulSteps",
   FAILED_STEPS: "failedSteps",
   IN_PROGRESS_STEPS: "inProgressSteps",
   STEPS_WITH_DATA_CHANGES: "stepsWithDataChanges",
   STEPS_WITHOUT_DATA_CHANGES: "stepsWithoutDataChanges",
   STEPS_WITH_USER_DEFINED_FIELDS: "stepsWithUserDefinedFields",
   STEPS_WITHOUT_USER_DEFINED_FIELDS: "stepsWithoutUserDefinedFields",
   RUNTIME_ERRORS: "runtimeErrors",
   AUTHORIZATION_ERRORS: "authorizationErrors",
   NETWORK_ERRORS: "networkErrors",
   USER_TRIGGERED_STEPS: "userTriggeredSteps",
   SYSTEM_TRIGGERRED_STEPS: "systemTriggerredSteps"
};

export const STEP_STATUSES = {
   SUCCESS: "Success",
   FAILED: "Failed",
   IN_PROGRESS: "In Progress"
};

export const EXECUTION_REPORT_PANEL_TABS = {
   TIMELINE_LOGS: "Execution Logs",
   ELASTIC_LOGS: "Elastic Logs",
   CONVERSATIONAL_LOGS: "Conversational Logs"
};

export const CONNECTOR_REQUIRED_FILES = ["package.json", "schema.json", "main.js"];

export const FLEX_LAYOUT_COMPONENT = {
   reactflow: "reactflow",
   componentProps: "componentProps",
   triggerProps: "triggerProps",
   context: "context",
   executionReport: "executionReport",
   startNode: "startNode"
};

export const FLEX_LAYOUT_COMPONENT_NAMES = {
   componentProps: "Component Properties",
   triggerProps: "Trigger Properties",
   context: "Context",
   executionReport: "Execution Report",
   startNode: "Start Node",
   home: "Home"
};

export const COMPONENT_PROPS_TAB_PREFIX = "componentProps-";

export const MAX_NUM_FLOW_CONFIG_PARAMETERS = 250;
export const MAX_FLOW_CONFIG_SIZE = 8192;
export const MAX_FLOW_CONFIG_KEY_SIZE = 64;
